import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MainButton } from 'elements/button/MainButton';
import { EFonts } from 'libs/styles/styling';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { EWorldColor } from 'static/config/worldVariables';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    email: string;
}

export const DetailBookingConfirmed = (props: Props) => {
    const ctxModal = useContext(CtxModal);

    return (
        <S_DetailBookingConfirmed className={props.className}>
            <S_IconContainer>
                <S_Icon icon={['fas', 'check-circle']} />
                <S_Title>{Localization.BOOKING_SUCCESS_TITLE}</S_Title>
            </S_IconContainer>

            <S_Text>
                {Localization.BOOKING_SUCCESS_MESSAGE}{' '}
                <strong>{Localization.BOOKING_SUCCESS_MESSAGE_CHECK_SPAM}</strong>
            </S_Text>

            <S_SubmitButton
                type={'primary'}
                alignText="center"
                onClick={() => {
                    ctxModal.closeAll();
                }}
            >
                {Localization.BOOKING_CLOSE_DIALOG}
            </S_SubmitButton>
        </S_DetailBookingConfirmed>
    );
};

const S_DetailBookingConfirmed = styled.div``;

const S_Text = styled.div`
    margin-bottom: 25px;
    font-family: ${EFonts.Regular};
    line-height: 1.4em;
`;

const S_SubmitButton = styled(MainButton)`
    height: 50px;
    width: 300px;
    margin: 10px auto;
`;

const S_IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 60px;
    color: #${EWorldColor.GREEN};
    margin-bottom: 20px;
`;

const S_Title = styled.div`
    font-family: ${EFonts.Bold};
    text-align: center;
    margin-bottom: 20px;
`;
